import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    apercuShow : false,
    ajoutsuccess : false,
    modifsuccess : false,
    listVendeurs : [],
    listCamions : [],
    current : [],
}
const RetoursCamion = createSlice({
    name : 'RetoursCamionData',
    initialState,
    reducers :{
        ajoutsuccess:(state,action) =>{
            state.ajoutsuccess=action.payload
        },
        idretour:(state,action) =>{
            state.current=action.payload
        },
        showapercu:(state,action) =>{
            state.apercuShow=action.payload
        },
        modifsuccess:(state,action) =>{
            state.modifsuccess=action.payload
        },
        getvendeurs:(state,action) =>{
            state.listVendeurs=action.payload
        },
        getcamions:(state,action) =>{
            state.listCamions=action.payload
        },
    }
})
export const {ajoutsuccess,idretour,showapercu,modifsuccess,getvendeurs,getcamions} = RetoursCamion.actions
export default RetoursCamion.reducer;